import { useNavigate } from 'react-router';
import InformationCard from '~/components/BookingFlow/Information/InformationCard';
import Button from '~/components/General/Button';
import useTranslation from '~/hooks/useTranslation';
import utilStyles from '~/styles/utils.module.css';
import bookingFlowRoutes from '~/routes/bookingFlow';
import BookingFlowLayout from '../Layout/Layout';

function BookingFlowThanks() {
  const translate = useTranslation();
  const navigate = useNavigate();

  return (
    <BookingFlowLayout
      step={3}
      sidebarVisible={false}
      showDisclaimer={false}
      sidebarActions={null}
      contentActions={null}
    >
      <h1 className={utilStyles.srOnly}>
        {translate('bookingFlow.thanks.title')}
      </h1>

      <InformationCard
        title={translate('bookingFlow.thanks.title')}
        className={utilStyles.mbMedium}
      >
        <p>{translate('bookingFlow.thanks.description')}</p>
      </InformationCard>

      <Button
        onClick={() => navigate(bookingFlowRoutes.OVERVIEW)}
      >
        Back to step 1 (for demo purposes)
      </Button>
    </BookingFlowLayout>
  );
}

export default BookingFlowThanks;
